import axios from 'axios';


const handleDownloadStudy = async (
  accountId, checkDownloadLink, checkInterval, downloadStudyLink,
  downloadZipUrl, patientName, setDownloadStatus, studyId, user
) => {
  try {
    setDownloadStatus('zipping');

    const { shortKey, downloadUrl } = await axios
      .get(downloadStudyLink)
      .then((res) => res.data);

    downloadZipUrl.current = downloadUrl;

    let id = setInterval(checkDownload, checkInterval);

    async function checkDownload() {
      const result = await axios
        .get(`${checkDownloadLink}&shortKey=${encodeURIComponent(shortKey)}`)
        .then((res) => res.data)
        .catch((e) => {
          clearInterval(id);
          setDownloadStatus(e.toString());
        });
      if (result === true) {
        clearInterval(id);
        setDownloadStatus('done');

        axios.post('/external/insertResultsPortalLogs', {
          type: 'resultsPortal',
          subType: 'downloadDicoms',
          studyId,
          patientName,
          accountId,
          user: {
            username: user.username,
            typeUser: user.type === 'medico'
              ? 'Médico solicitante'
              : user.type === 'paciente' ? 'Paciente' : 'Prestador'
          }
        });
      }
    }
  } catch(e) {
    console.log('Error downloading zip: ', e.toString());
    setDownloadStatus(e.toString());
  }
}

export default handleDownloadStudy;